/*
 * Psydeck PT | EN switch (snippets/psydeck-language-toggle.liquid, which loads it, and the
 * mobile menu footer). A navy pill sits behind the current language; picking
 * the other one slides the pill across, then submits the localization form.
 * Without this script the forms still work: the current button is navy and a
 * click submits straight away.
 */
(function () {
  if (window.psyLangSwitch) return;
  window.psyLangSwitch = true;

  var FORMS = '.psy-lang, .psy-mm__lang';
  var BUTTONS = '.psy-lang__btn, .psy-mm__lang-btn';
  var SLIDE_MS = 220;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function current(form) {
    return form.querySelector('.is-current');
  }

  // Moves the pill under a button; without animate it jumps there.
  function place(form, btn, animate) {
    var pill = form.querySelector('.psy-lang-pill');
    if (!pill || !btn) return;
    var b = btn.getBoundingClientRect();
    if (!b.width) return;
    // Measured from the form's padding edge, which is where the pill's left: 0 sits.
    var left = b.left - form.getBoundingClientRect().left - form.clientLeft;
    if (!animate) pill.style.transition = 'none';
    pill.style.width = b.width + 'px';
    pill.style.transform = 'translateX(' + left + 'px)';
    if (!animate) {
      void pill.offsetWidth;
      pill.style.transition = '';
    }
    form.classList.add('is-ready');
  }

  function setCurrent(form, btn) {
    var cur = current(form);
    if (cur) {
      cur.classList.remove('is-current');
      cur.removeAttribute('aria-current');
    }
    btn.classList.add('is-current');
    btn.setAttribute('aria-current', 'true');
  }

  function setup(form) {
    if (form.dataset.psyLangReady) return;
    form.dataset.psyLangReady = '1';
    var cur = current(form);
    form.dataset.psyLangCurrent = cur ? cur.value : '';
    var pill = document.createElement('span');
    pill.className = 'psy-lang-pill';
    pill.setAttribute('aria-hidden', 'true');
    form.insertBefore(pill, form.firstChild);
    place(form, cur, false);
    // The mobile menu's form has no size while the drawer is closed; place the
    // pill once it shows, and again if the font loads late or the text changes.
    if (window.ResizeObserver) {
      new ResizeObserver(function () { place(form, current(form), false); }).observe(form);
    }
  }

  function submit(form, btn) {
    if (form.requestSubmit) {
      form.requestSubmit(btn);
      return;
    }
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = btn.name;
    input.value = btn.value;
    form.appendChild(input);
    form.submit();
  }

  function init() {
    document.querySelectorAll(FORMS).forEach(setup);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest(BUTTONS);
    if (!btn || !btn.form) return;
    var form = btn.form;
    // The language already shown: nothing to do.
    if (btn.classList.contains('is-current')) {
      event.preventDefault();
      return;
    }
    // Already sliding: a second click must not start its own submit.
    if (form.dataset.psyLangBusy) {
      event.preventDefault();
      return;
    }
    if (reduce.matches || !form.classList.contains('is-ready')) return;
    event.preventDefault();
    form.dataset.psyLangBusy = '1';
    setCurrent(form, btn);
    place(form, btn, true);
    setTimeout(function () { submit(form, btn); }, SLIDE_MS);
  });

  // Back from the next page (bfcache): show the language this page is in again.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll(FORMS).forEach(function (form) {
      delete form.dataset.psyLangBusy;
      var btn = form.querySelector('button[value="' + form.dataset.psyLangCurrent + '"]');
      if (!btn) return;
      setCurrent(form, btn);
      place(form, btn, false);
    });
  });

  // Theme Editor re-renders the header section.
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
